var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/register/steps/RegisterLegalNotices.tsx";
import React, { useCallback, useEffect, useState } from 'react';
import { Button, CheckboxListCard, CheckboxListItem, Stack, VStack } from '@adc/parallax-component-library';
import { Footer, Form, Header, LogoActionBar, Main, RichText, ScrollContainer } from 'Components/utility';
import { SHOW_MODAL } from 'Reducers/modal/types';
import { REGISTER } from 'Reducers/register/types';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
const RegisterLegalNotices = ({
  next,
  back,
  values,
  currentStep
}) => {
  const [termsOfUseChecked, setTermsOfUseChecked] = useState(false);
  const [privacyNoticeChecked, setPrivacyNoticeChecked] = useState(false);
  useEffect(() => {
    const touLibre = values.consents.find(consent => consent.id === 'touLibre');
    const pp = values.consents.find(consent => consent.id === 'pp');
    setTermsOfUseChecked(touLibre?.action === 'accept');
    setPrivacyNoticeChecked(pp?.action === 'accept');
  }, [values]);
  const handleLinkClick = href => {
    store.dispatch({
      type: REGISTER,
      register: {
        ...values,
        currentStep,
        consents: [{
          id: 'touLibre',
          action: termsOfUseChecked ? 'accept' : 'decline'
        }, {
          id: 'pp',
          action: privacyNoticeChecked ? 'accept' : 'decline'
        }]
      }
    });
    mediator.publish('router:navigate', href);
  };
  const showAcceptTermsError = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: i18n.t('LegalNotices.modals.tapCheckbox.body'),
        testID: 'LegalNotices.modals.tapCheckbox.body'
      }
    });
  }, []);
  const onSubmit = useCallback(declined => {
    if (!termsOfUseChecked || !privacyNoticeChecked || declined) {
      showAcceptTermsError();
      return;
    }
    const register = {
      ...values,
      consents: [{
        id: 'touLibre',
        action: 'accept'
      }, {
        id: 'pp',
        action: 'accept'
      }]
    };
    next(register);
  }, [next, privacyNoticeChecked, showAcceptTermsError, termsOfUseChecked, values]);
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(LogoActionBar, {
    actionButtonTestID: "RegisterLegalNotices.action-go-back",
    titleTestID: "RegisterLegalNotices.actionTitle",
    title: i18n.t('LegalNotices.title'),
    onBack: back,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(ScrollContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 110,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Header, {
    titleTestID: "RegisterLegalNotices.title",
    title: i18n.t('LegalNotices.title'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Form, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 115,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    gap: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 116,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(RichText, {
    onPressLink: handleLinkClick,
    testID: "RegisterLegalNotices.bodyText",
    text: i18n.t('LegalNotices.content.legalNoticeCopy.bodyText'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(CheckboxListCard, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(CheckboxListItem, {
    checked: termsOfUseChecked,
    onPress: () => setTermsOfUseChecked(!termsOfUseChecked),
    testID: "RegisterLegalNotices.acceptTermsOfUse",
    title: i18n.t('LegalNotices.content.acceptTermsOfUse.primaryText'),
    label: i18n.t('LegalNotices.content.acceptTermsOfUse.secondaryText'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(CheckboxListCard, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(CheckboxListItem, {
    checked: privacyNoticeChecked,
    onPress: () => setPrivacyNoticeChecked(!privacyNoticeChecked),
    testID: "RegisterLegalNotices.acceptPrivacyNotice",
    title: i18n.t('LegalNotices.content.acceptPrivacyNotice.primaryText'),
    label: i18n.t('LegalNotices.content.acceptPrivacyNotice.secondaryText'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 133,
      columnNumber: 15
    }
  }))))), /*#__PURE__*/React.createElement(Footer, {
    customProps: /*#__PURE__*/React.createElement(VStack, {
      padding: "$4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 146,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onPress: () => onSubmit(),
      testID: "RegisterLegalNotices.accept-btn",
      label: i18n.t('Global.microcopy.common.accept'),
      "aria-label": i18n.t('Global.microcopy.common.accept'),
      marginBottom: "$4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 147,
        columnNumber: 13
      }
    }), /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      testID: "RegisterLegalNotices.decline-btn",
      label: i18n.t('Global.microcopy.common.decline'),
      "aria-label": i18n.t('Global.microcopy.common.decline'),
      onPress: () => onSubmit(true),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 154,
        columnNumber: 13
      }
    })),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 144,
      columnNumber: 7
    }
  }));
};
export default RegisterLegalNotices;